import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import adminContentApi from "../../api/admin/AdminContent";
import { DocumentListReq, DocumentListResp } from "../../../types/files";
// # initial state
const initialState = {
  contentList: {} as DocumentListResp,
};

export const trunkGetContentList = createAsyncThunk(
  "wapi/admins/contents/list",
  async (logSearchOptions: DocumentListReq) => {
    const resp = await adminContentApi.getContentList(logSearchOptions);
    return resp;
  }
);

export const trunkDeleteDocNow = createAsyncThunk(
  "wapi/admins/contents/delete/now",
  async (syncIds: string[]) => {
    const resp = await adminContentApi.deleteDocNow(syncIds);
    return resp;
  }
);

export const trunkRestoreDoc = createAsyncThunk(
  "wapi/admins/contents/restore",
  async (syncIds: string[]) => {
    const resp = await adminContentApi.restoreDoc(syncIds);
    return resp;
  }
);

const adminContentSlice = createSlice({
  name: "adminContent",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      trunkGetContentList.fulfilled,
      (state, { payload: newContentList }) => {
        state.contentList = newContentList;
      }
    );
  },
});

export const adminContentActions = adminContentSlice.actions;
export default adminContentSlice.reducer;
